import React from "react";

export const RadioButton = (props) => {
    const { text, checked, onChange } = props;

    return (
        <label className="sidebarContent_links_container">
            {text}
            <input
                type="radio"
                name="radio"
                checked={checked ? checked : false}
                onChange={() => {
                    onChange();
                }}
            />

            <span className="sidebarContent_links_checkmark"></span>
        </label>
    );
};
